import { useAuth, useRequest } from '@polvo-labs/react-auth'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setTimeout } from 'timers'
import routes from '../../config/routes'
import { useSocket } from '../../Socket'
import Button from '../Button'
import Icon from '../Icon'
import Modal from '../Modal'
import Text from '../Text'
import { Actions, Container } from './styles'

interface Props {

}

const Logout: React.FC<Props> = () => {
  const { logout, user } = useAuth()
  const { request } = useRequest()
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const socket = useSocket()

  return (
    <>
      <Button
        before={(
          <Icon
            name="logout"
          />
        )}
        label="Sair"
        backgroundColor="transparent"
        fontColor="darkGray"
        alignText="flex-start"
        onClick={() => setOpen(true)}
      />

      <Modal
        open={open}
        small
        onToggle={open => setOpen(open)}
      >
        <Container>
          <Text
            tag="h2"
            align="center"
          >
            DESEJA SAIR DA SESSÃO ATUAL?
          </Text>

          <Actions>
            <Button
              label="SIM"
              block
              backgroundColor="white"
              borderColor="lightGray"
              fontColor="darkBlue"
              onClick={() => {
                setTimeout(() => {
                  request({
                    method: 'DELETE',
                    url: `${process.env.REACT_APP_API_URL}/sessions/${user.current_session.id}`,
                  }).then(() => {
                    window.localStorage.clear()        
                    socket?.disconnect()            
                    logout!()
                    history.push(routes.index.path)
                    toast.success('Deslogado com sucesso')
                  })
                }, 0);
              }}
            />
            <Button
              label="NÃO"
              block
              backgroundColor="white"
              borderColor="lightGray"
              fontColor="darkBlue"
              onClick={() => setOpen(false)}
            />
          </Actions>
        </Container>
      </Modal>
    </>
  )
}

export default Logout
